import React from 'react'
import SuccessfulPaymentImg from '../assets/img/successfulPayment.png'
// import MainButton from '../components/btns/MainButton'
import PurpleBtn from '../components/btns/PurpleBtn'
import { useNavigate } from 'react-router-dom'

const SuccessfulPaymentPage = () => {
    const navigate = useNavigate();

    const backHome = () => {
        navigate('/')
    }
  return (
    <>
    <div className='flex justify-center items-center w-full h-screen'>
        <div className='max-w-[350px]'>
            <img src={SuccessfulPaymentImg} alt="" className='max-w-[350px]'/>
            <p className='text-white font-semibold text-center'>Əməliyyat uğurla tamamlandı</p>
            <div className='flex justify-center mt-4'>
                <PurpleBtn onClick={backHome} title={'Qayıt'}/>
            </div>
        </div>

    </div>
    </>
  )
}

export default SuccessfulPaymentPage